import { PaginationType } from 'common';
import { FilesActionType } from 'enums';
import { FileType } from 'state';

export const setFiles = (files: FileType[]) =>
  ({ type: FilesActionType.SET_FILES, files } as const);

export const setFilesPagination = (pagination: PaginationType) =>
  ({ type: FilesActionType.SET_FILES_PAGINATION, pagination } as const);
